import React from 'react';
import {
    FormDialog,
    FormInput,
    http,
    useForm,
} from '../m34n-ui/src/lib';

import { isEmpty } from 'lodash';

const ProductAddModal = (props) => {
    const {
        state,
        onChange,
        onChangeBulk,
        onInvalidForm,
        onResetFormErrors,
    } = useForm({
        initialState: {
            name: '',
            description: '',
            price: '',
        },
    });
    const {
        config,
        isOpen,
        onChangeBulk: parentOnChangeBulk,
    } = props;

    return (
        <FormDialog
            dialogTitle="Add New Product"
            dialogSubHeading="Fill in the details to create a new product"
            handleClose={() => {
                onResetFormErrors();
                onChangeBulk({
                    name: '',
                    description: '',
                    price: '',
                });
                parentOnChangeBulk({ productAddModalIsOpen: false });
            }}
            handleSubmit={async () => {
                const errors = {};
                if (!state.values.name) errors.name = 'Product name is required';
                if (!state.values.price) errors.price = 'Price is required';

                if (!isEmpty(errors)) return onInvalidForm(errors);

                const data = {
                    name: state.values.name,
                    description: state.values.description,
                    price: state.values.price,
                };

                await http.post(data, `${config.uri.base}/product`);

                onChangeBulk({
                    name: '',
                    description: '',
                    price: '',
                });

                parentOnChangeBulk({
                    productAddModalIsOpen: false,
                });
            }}
            isOpen={isOpen}
        >
            <FormInput
                path="name"
                value={state.values.name}
                error={state.errors.name}
                onChange={onChange}
                label="Product Name"
                fullWidth
            />
            <FormInput
                path="description"
                value={state.values.description}
                error={state.errors.description}
                onChange={onChange}
                label="Description"
                fullWidth
                multiline
            />
            <FormInput
                path="price"
                value={state.values.price}
                error={state.errors.price}
                onChange={onChange}
                label="Price"
                fullWidth
            />
        </FormDialog>
    );
};

export default ProductAddModal;
